module.exports = __webpack_public_path__ + "img/so-long-and-thanks-for-all-the-fish.3356e42b.png";